import * as React from "react";
import { isAndroid } from "../../utils/Utils";
var moment = require("moment");
function FooterLanding({ telText, emailText }: { telText: string; emailText: string }) {
  let num = <span>{telText}</span>;
  let mail = <span>{emailText}</span>;

  /* fix for android standard browser which sometimes wrongly detects phone numbers somewhere */
  if (isAndroid()) {
    num = (
      <a href={"tel:" + telText}>
        <span>{telText}</span>
      </a>
    );
    mail = (
      <a href={"mailto:" + emailText}>
        <span>{emailText}</span>
      </a>
    );
  }

  return (
    <div className="main-footer is-landing">
      <div className="background-black">
        <div className="container">
          <div className="row padding-top-m">
            <div className="col-xs-4">
              <img
                className="img-responsive img-center margin-top-s"
                src="/images/LogoFooter.png"
                alt="Trust"
              />
            </div>

            <div className="col-md-3 col-md-offset-5 col-xs-8">
              <div>
                <div className="text-15 text-open-sans text-primary text-bold margin-top-s">
                  NOUS SOMMES CONNECTÉS
                </div>
                <div className="text-15 text-open-sans white-text text-bold margin-top-s">
                  {<div>{mail}</div>}
                </div>
                <ul className="list-inline list-unstyled">
                  <Link
                    imgSrc="/images/twitter-square.png"
                    location="https://twitter.com/_medGo_"
                  />
                  <Link
                    imgSrc="/images/facebook-square.png"
                    location="https://www.facebook.com/wearemedgo"
                  />

                  <Link
                    imgSrc="/images/linkedin.png"
                    location="https://www.linkedin.com/company/medgo-rempla"
                  />
                </ul>
              </div>
            </div>
            <div className="clearfix" />
            <div className="primary_section text-center">
              <ul className="list-inline list-unstyled">
                <li className="margin-top-m-fixe text-10">
                  © {moment().format("YYYY")}. Tous droits réservés.
                </li>
                <li className="margin-top-m-fixe text-10">
                  <a href="/terms">Conditions générales d'utilisation</a>
                </li>
              </ul>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

function Link({ imgSrc, location }: { imgSrc: string; location: string }) {
  return (
    <li className="margin-top-s">
      <a href={location} target="_blank">
        <img className="img-responsive img-center" alt="Logo" src={imgSrc} />
      </a>
    </li>
  );
}

export default FooterLanding;



// WEBPACK FOOTER //
// ./assets/react/views/Landing/FooterLanding.view.tsx